import React from 'react';

import promotion_config from '../../../promotion_config';
import EntryForm from './entry_form';
import Error from './error';

import ticketFront from './images/entry-number-box-sample.png';
import ticketBack from './images/ticket-number-box-sample.png';

import './style.scss';

export const EntryInner = ({ entry, drawTicket, game, animation, actions }) => {
    return (
        <div className='entry-div'>
            <div className='flush-row'>
                <div className='col-sm-10 col-sm-offset-1 text-center entry-info'>
                    <div className='description'>
                        <p>
                            To enter, type the TICKET NUMBER and ENTRY NUMBER from one of the non-winning WILLY WONKA GOLDEN TICKET&trade; eligible Illinois
                            Lottery (Game #7402) instant ticket where indicated in the spaces below.
                        </p>
                    </div>
                    <div className='valid-entries'>
                        <p>
                            Only valid Internet Entries shall be accepted.
                            <br />
                            Mailing tickets to the Lottery is not a valid form of entry.
                        </p>
                    </div>
                </div>

                <div id='entry-alert'>
                    <Error drawTicket={drawTicket} actions={actions} />
                </div>

                <div className='col-sm-10 col-sm-offset-1 entry-container'>
                    <div className='entry-panel'>
                        <EntryForm
                            promotion_id={promotion_config.promotion_id}
                            promotion={promotion_config.promotion}
                            appUrl={promotion_config.appUrl}
                            drawTicket={drawTicket}
                            entry={entry}
                            game={game}
                            animation={animation}
                            actions={actions}
                            createfunc={actions.drawTicketActions.enterDrawTicket}
                        />
                    </div>
                </div>

                <div className='col-sm-12'>
                    <div className='row row-eq-height'>
                        <div className='col-xs-6 col-sm-5 col-sm-offset-1'>
                            <div className='entry-panel'>
                                <img src={ticketBack} alt='Ticket Number on ticket back.' className='img-responsive center-block' />
                                <div className='sr-only'>The Ticket Number is a 14-digit number that begins with 7402 located on the back of the ticket.</div>
                            </div>
                        </div>
                        <div className='col-xs-6 col-sm-5'>
                            <div className='entry-panel'>
                                <img src={ticketFront} alt='Entry Number on ticket front.' className='img-responsive center-block' />
                                <div className='sr-only'>The Entry Number is a 10-digit number in the game play area on the ticket front.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntryInner;
